import React from "react";
import { Box, Stack } from "@mui/material";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import ScheduleOutlinedIcon from "@mui/icons-material/ScheduleOutlined";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import SectionFrame from "../SectionFrame";
import { EditableButton, EditableText } from "../InlineEditable";
import EditableImage from "../EditableImage";

export default function ContactSection({ form, active, device, onSelect, onCommit, onUploadImage, onRemoveImage, disabled }) {
  const isMobile = device === "mobile";
  const primary = form.theme.primaryColor || "#F35A3A";
  const secondary = form.theme.secondaryColor || "#19242F";

  return (
    <SectionFrame id="contact" label="Contacto" active={active} enabled={form.sections.showContact !== false} onSelect={onSelect} onToggle={(next) => onCommit("sections.showContact", next)}>
      <Box
        sx={{
          px: isMobile ? 2.5 : 5,
          pr: isMobile ? 2.5 : 15,
          py: isMobile ? 6 : 8,
          display: "grid",
          gridTemplateColumns: isMobile ? "1fr" : "minmax(0,1.05fr) minmax(320px,.95fr)",
          gap: 4,
          bgcolor: secondary,
          color: "#fff",
        }}
      >
        <Box sx={{ alignSelf: "center" }}>
          <EditableText
            value={form.contact.title}
            fallback="Hablemos"
            disabled={disabled}
            onSave={(value) => onCommit("contact.title", value)}
            sx={{ fontWeight: 950, fontSize: isMobile ? 34 : 46, letterSpacing: "-.035em" }}
          />
          <Box sx={{ mt: 1.2, maxWidth: 620 }}>
            <EditableText
              value={form.contact.subtitle}
              fallback="Dejá una invitación clara para que tus clientes se comuniquen con el negocio."
              disabled={disabled}
              multiline
              minRows={3}
              onSave={(value) => onCommit("contact.subtitle", value)}
              sx={{ color: "rgba(255,255,255,.78)", lineHeight: 1.7 }}
            />
          </Box>

          <Stack spacing={1.3} sx={{ mt: 2.5 }}>
            <Stack direction="row" spacing={1} alignItems="center">
              <LocationOnOutlinedIcon sx={{ color: primary }} />
              <EditableText
                value={form.business.address}
                fallback="Dirección del negocio"
                disabled={disabled}
                onSave={(value) => onCommit("business.address", value)}
                sx={{ color: "rgba(255,255,255,.88)", fontWeight: 750 }}
              />
            </Stack>
            <Stack direction="row" spacing={1} alignItems="center">
              <ScheduleOutlinedIcon sx={{ color: primary }} />
              <EditableText
                value={form.business.schedule}
                fallback="Horarios de atención"
                disabled={disabled}
                onSave={(value) => onCommit("business.schedule", value)}
                sx={{ color: "rgba(255,255,255,.88)", fontWeight: 750 }}
              />
            </Stack>
          </Stack>

          <Stack direction={isMobile ? "column" : "row"} spacing={1.4} sx={{ mt: 3 }}>
            <Stack direction="row" alignItems="center" spacing={0.6}>
              <WhatsAppIcon />
              <EditableButton
                value={form.contact.whatsappCtaLabel}
                fallback="Escribir por WhatsApp"
                disabled={disabled}
                onSave={(value) => onCommit("contact.whatsappCtaLabel", value)}
                sx={{ bgcolor: primary, color: "#fff", borderRadius: 999, px: 2.5, py: 1.1, fontWeight: 950 }}
              />
            </Stack>
            <EditableButton
              value={form.contact.detailsCtaLabel}
              fallback="Ver contacto"
              disabled={disabled}
              variant="outlined"
              onSave={(value) => onCommit("contact.detailsCtaLabel", value)}
              sx={{ bgcolor: "transparent", color: "#fff", borderColor: "rgba(255,255,255,.62)", borderRadius: 999, px: 2.5, py: 1.05, fontWeight: 900 }}
            />
          </Stack>
        </Box>

        <EditableImage
          value={form.contact.backgroundImageUrl}
          label="Imagen o mapa de contacto"
          height={isMobile ? 250 : 340}
          disabled={disabled}
          onUpload={(file) => onUploadImage("contact.backgroundImageUrl", file, { sectionKey: "contact", assetKey: "background" })}
          onRemove={() => onRemoveImage("contact.backgroundImageUrl")}
          sx={{ bgcolor: "rgba(255,255,255,.08)", borderColor: "rgba(255,255,255,.34)" }}
        />
      </Box>
    </SectionFrame>
  );
}
